import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

const StyledAbout = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 1em;
  flex: 1;
  text-align: justify;
`;
const Link = styled.a`
  display: inline-block;
  color: var(--black);
  &:hover {
    text-decoration: none;
  }
  ${({ bold }) => bold && `font-weight: bold`}
`;
const Credit = styled.p`
  font-style: italic;
`;

function About() {
  return (
    <>
      <Helmet>
        <title>Covid-19 čakáreň dáta - O projekte</title>
        <meta
          name="description"
          content="Zistite koľko ľudí je pred vami v čakárni na vakcínu proti Covid-19 (1. dávka)!"
        />
        <link rel="canonical" href="https://cakaren.vercel.app/projekt" />
        <meta property="og:url" content="https://cakaren.vercel.app/projekt" />
        <meta
          property="og:image"
          content="https://cakaren.vercel.app/preview.png"
        />
        <meta property="og:title" content="Covid-19 čakáreň kalkulačka" />
        <meta
          property="og:description"
          content="Zistite koľko ľudí je pred vami v čakárni na vakcínu proti Covid-19 (1. dávka)!"
        />
      </Helmet>
      <StyledAbout>
        <p>
          Projekt vznikol za účelom jednoduchej vizualizácie verejne dostupných
          dát z čakárne na vakcínu proti Covid-19. Cieľom bolo sprístupniť tieto
          dáta všetkým ľuďom online vo forme interaktívnej webovej aplikácie,
          kde nájdu vždy najaktuálnejšie údaje s možnosťou filtrovania.
        </p>
        <br />
        <p>
          Druhá verzia aplikácie priniesla taktiež kalkulačku, vďaka ktorej
          návštevníci nemusia skúmať grafy a jednoducho zistia koľko ľudí sa
          pred nimi nachádza v rade na 1. dávku.
        </p>
        <br />
        <p>
          Dáta za každý deň sú k času 19:00 a IZA ich zvyčajne zverejňuje
          nasledujúci deň o 10:00.
        </p>
        <br />
        <br />
        <Credit>
          Credit: nápad na vizualizáciu dát{' '}
          <Link
            href="https://www.facebook.com/jan.suchal/posts/10159119107184184"
            target="_blank"
          >
            Jano Suchal a Filip Likavčan
          </Link>{' '}
          (vďaka!)
        </Credit>
        <br />
        <p>
          <strong>✉️ Kontakt na autora projektu: </strong>
          <Link href="mailto:cakaren.data@gmail.com" bold>
            cakaren.data@gmail.com
          </Link>
        </p>
      </StyledAbout>
    </>
  );
}

export default About;
